import { render, staticRenderFns } from "./ServiceQuestionDetail.vue?vue&type=template&id=4aec4304"
import script from "./ServiceQuestionDetail.vue?vue&type=script&lang=js"
export * from "./ServiceQuestionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports